import { DOCUMENT } from '@angular/common';
import { Component, Inject, ViewChild, ViewContainerRef, inject } from '@angular/core';

import { RecallService } from '@app/services/recall.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    @ViewChild('modal', {
        read: ViewContainerRef,
    })
    modal: ViewContainerRef;

    public showHeaderFooter = true;
    private recallService: RecallService = inject(RecallService);

    constructor(@Inject(DOCUMENT) private document: Document) {
        if (document.defaultView.hasOwnProperty('Cypress')) {
            this.showHeaderFooter = false;
        } else {
            this.showHeaderFooter =
                document.defaultView['SHOW_HEADER'] !== undefined ? document.defaultView['SHOW_HEADER'] : false;
        }

        const routesWithoutHeaderFooter: string[] = ['/test-eligibilite-fibre', '/prise-interet'];
        routesWithoutHeaderFooter.forEach((i) => {
            if (document.defaultView.location.pathname.includes(i)) {
                this.showHeaderFooter = false;
            }
        });

        this.recallService.initRouteHandler().subscribe();
    }
}
